module.exports = __webpack_public_path__ + "img/alipay.268d943d.png";